export const SET_ANSWERS = 'SET_ANSWERS';
export const SET_QUESTIONS = 'SET_QUESTIONS';
export const SET_LOADING = 'SET_LOADING';
export const SET_VOUCHER = 'SET_VOUCHER';
export const SET_ESTADOS = 'SET_ESTADOS';
export const SET_CIDADES = 'SET_CIDADES';
export const SET_ALERT = 'SET_ALERT';
export const SET_STEP = 'SET_STEP';
export const SET_DISABLED_BUTTONS = 'SET_DISABLED_BUTTONS';
export const SET_IS_VISIBLE_PARY_CONFETTI = 'SET_IS_VISIBLE_PARY_CONFETTI';
export const SET_CONFIG = 'SET_CONFIG';
export const SET_BAIRROS = 'SET_BAIRROS';